import axios from "axios";

// Create an Axios instance with default settings
const apiClient = axios.create({
  baseURL: "https://ksvidyalay.com/back/index.php/stdapi/", // Replace with your API URL
  timeout: 10000, // Optional: Set a timeout
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});

// Add a request interceptor to include the token
apiClient.interceptors.request.use(
  (config) => {
    const loader = document.getElementById('global-loader');
    if (loader) loader.style.display = 'flex';

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  (error) => {
    const loader = document.getElementById('global-loader');
    if (loader) loader.style.display = 'none';
    return Promise.reject(error);
  }
);

// Handle response errors globally (optional)
apiClient.interceptors.response.use(
  (response) => {
    const loader = document.getElementById('global-loader');
    if (loader) loader.style.display = 'none';
    if (response.data?.logged === false){
        localStorage.removeItem("token");
            window.location.href = "/";        
    }
    
    return response;
  },
  (error) => {
    const loader = document.getElementById('global-loader');
    if (loader) loader.style.display = 'none';
     
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      // window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default apiClient;
